import {DataLayerType} from "./customDatalayerInterface";
import {CustomWindow} from "./custom.window";

declare let window: CustomWindow;

const digitalDataAssignment = (dataLayer: DataLayerType) => {
    window.digitalData?.pushAndUpdate(dataLayer);
}

export default digitalDataAssignment;